import type {WalletOption} from 'src/v2/state/types';
import {isMobile} from 'src/utils/utils';

// mapped values come from lib/cryptocurrency/payins/core/constants/wallet_provider.rb
const DISABLED_WALLET_PROVIDERS_MAPPING = {
  MetaMask: 'metamask',
  Phantom: 'phantom',
  'Coinbase Wallet': 'coinbase_wallet',
  WalletConnect: 'wallet_connect',
};

const MOBILE_DISABLED_WALLET_PROVIDERS_MAPPING = {
  MetaMask: 'dynamic-mobile-metamask',
  Phantom: 'dynamic-mobile-phantom',
  'Coinbase Wallet': 'dynamic-mobile-coinbase',
  WalletConnect: 'dynamic-mobile-walletconnect',
};

export const isWalletProviderDisabled = (
  walletOption: WalletOption,
  disabledProviders: string[],
): boolean => {
  const isOnMobile = isMobile();

  if (
    disabledProviders.includes(
      DISABLED_WALLET_PROVIDERS_MAPPING[walletOption.provider],
    )
  ) {
    return true;
  }

  const mobileProviderKey =
    MOBILE_DISABLED_WALLET_PROVIDERS_MAPPING[walletOption.provider];
  if (
    isOnMobile &&
    mobileProviderKey &&
    disabledProviders.includes(mobileProviderKey)
  ) {
    return true;
  }

  return false;
};
